/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * The `di` module provides dependency injection container services.
 */
export { Inject, Optional, Injectable, Self, SkipSelf, Host } from "./di/metadata";
export { forwardRef, resolveForwardRef } from "./di/forward_ref";
export { Injector } from "./di/injector";
export { ReflectiveInjector } from "./di/reflective_injector";
export { ResolvedReflectiveFactory } from "./di/reflective_provider";
export { ReflectiveKey } from "./di/reflective_key";
export { InjectionToken } from "./di/injection_token";
//# sourceMappingURL=di.js.map


// WEBPACK FOOTER //
// ../../../packages/core/esm5/src/di.js